import { SVGProps } from 'react';

const Shipyard = ({
  props,
  fill = 'currentColor',
  size = 24,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={fill}
      d="M12.75 2.75H15l.097.006a.75.75 0 0 1 .574 1.079l-1 2A.75.75 0 0 1 14 6.25h-1.25V8H12l-.073.005a.501.501 0 0 0-.29.838l.004-.001a.751.751 0 0 1 .718 0h.002A.5.5 0 0 0 12.5 8.5H14a2 2 0 0 1-.31 1.068l4.001 2.183H19a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-.75.75H5a.75.75 0 0 1-.75-.75v-8a.75.75 0 0 1 .75-.75h1.309l4-2.183a1.995 1.995 0 0 1 .941-2.92V6.25H10a.75.75 0 0 1-.67-.415l-1-2A.75.75 0 0 1 9 2.75h2.25V2h1.5v.75Zm-7 17h12.5v-6.5H5.75v6.5Zm4-.75h-1.5v-5h1.5v5Zm3 0h-1.5v-5h1.5v5Zm3 0h-1.5v-5h1.5v5Zm-3.51-8.516c-.16.02-.322.02-.482.001L9.44 11.75h5.118l-2.32-1.266ZM10.463 4.75h3.072l.25-.5h-3.572l.25.5Z"
    />
  </svg>
);

export default Shipyard;
